<!--
 * @Description: 自定义卡片
 * @version: 1.0.0
 * @Author: Monkey
 * @Date: 2025-04-24 21:34:40
 * @LastEditors: Monkey
 * @LastEditTime: 2025-06-29 13:01:02
-->
<template>
  <el-card shadow="never" class="alljoinsComponents" :style="cardStyle">
    <template #header>
      <div class="card-header" @click="handleCardTitleClick">
        <span>{{ title }}</span>
        <span v-show="!cardShow" class="el-form-item-aux">(点击可展开)</span>
        <el-icon class="action" v-show="cardShow"><el-icon-arrow-down /></el-icon>
        <el-icon class="action" v-show="!cardShow"><el-icon-arrow-up /></el-icon>
      </div>
    </template>

    <div v-show="cardShow" class="card-content" :style="contentStyle">
      <slot />
    </div>
  </el-card>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue'

const props = defineProps({
  // 卡片标题
  title: { type: String, default: '' },
  // 初始是否展开
  cardKey: { type: Boolean, default: true },
  // 内容区域最大高度
  maxHeight: { type: String, default: '' }
})

// 卡片是否显示
const cardShow = ref(false)
const handleCardTitleClick = async () => {
  cardShow.value = !cardShow.value
  await nextTick()
}

// 计算卡片内容区域样式
const contentStyle = computed(() => {
  const styles = {}
  if (props.maxHeight) {
    styles.maxHeight = props.maxHeight
    styles.overflowY = 'auto'
  }
  return styles
})

// 计算卡片整体样式（用于过渡效果）
const cardStyle = computed(() => {
  return {
    transition: 'all 0.3s ease'
  }
})

onMounted(() => {
  cardShow.value = props.cardKey
})
</script>

<style lang="scss" scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding: 12px 16px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.5s;

  // &:hover {
  //   background-color: var(--el-bg-color-page);
  // }

  .el-form-item-aux {
    font-size: 12px;
    color: var(--el-text-color-secondary);
    margin-left: 8px;
  }

  .action {
    transition: transform 0.3s;
  }
}

.card-content {
  padding: 0 16px 16px;
  transition: max-height 0.3s ease;

  // 添加滚动条美化
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: var(--el-bg-color-page);
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--el-border-color-light);
    border-radius: 3px;

    &:hover {
      background-color: var(--el-border-color);
    }
  }
}

// 折叠时的平滑过渡
.alljoinsComponents {
  transition: all 0.3s ease;
}
</style>